// import { useState, useEffect } from "react";
// import axios from '../helper/axios';
// import Autocomplete from "@mui/material/Autocomplete";
// import debounce from "lodash.debounce";
// import {
//   TextField,
//   InputAdornment,
//   IconButton,
// } from "@mui/material";
// import SearchIcon from '@mui/icons-material/Search';
// import {  toast } from 'react-toastify';
// import {  useHistory } from 'react-router-dom';
// import { useUser } from "../Provider";
// const Searchbar = ({ onSearchChange }) => {
//   const {user, userHospitalcode, userrole1, isAuthRole,isAuthorized,gettokenId,token  } = useUser();
//   const [value, setValue] = useState("");
//   const [data, setData] = useState([]);
//   const [open, setOpen] = useState(false); // State to control dropdown visibility
//   const [selectedValue, setSelectedValue] = useState(null); // State to store selected value
//   const [searchTerm, setSearchTerm] = useState("");
// //when page load or refresh happen this function will got called
// // useEffect(() => {
// //   const loadData = async () => {
// //    // await loadAllDetails();
// //     //loadAllAppointment(); will wait for loadAllDetails(); to got execute
// //     await loadAllPatients();
// //   };

// //   loadData();
// // }, [userrole1,userHospitalcode]);
// //   const loadAllPatients = async () => {
// //     try {
    
// //       if (userHospitalcode !== undefined && userrole1 !== undefined) {
// //       const res = await axios.get("/GetPatientAPI", {
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //         },
// //         params: {
// //           hospitalcode: userHospitalcode, // Include the hospitalcode in the query parameters
// //           userrole: userrole1, // Include the userrole in the query parameters
// //         },
// //       });
      
// //       setData(res.data);
// //       console.log(res.data);
// //     } }catch (error) {
// //       // Handle client-side errors here
// //       if (error.request) {
// //         // The request was made, but no response was received
// //         toast.error("No response received from the server");
// //       } else {
// //         // Something else went wrong
// //         toast.error("Error:", error.message);
// //       }
// //     }
// //   };


// const loadFilteredPatients = async (term) => {
//   try {
//     const res = await axios.get("/GetPatientAPI", {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       params: {
//         hospitalcode: userHospitalcode,
//         userrole: userrole1,
//         searchTerm: term, // pass search term here
//       },
//     });

//     setData(res.data);
//   } catch (error) {
//     toast.error("Error fetching patient data");
//   }
// };

// const debouncedSearch = debounce((term) => {
//   if (term) {
//     loadFilteredPatients(term);
//   }
// }, 500); // 500ms debounce

// useEffect(() => {
//   debouncedSearch(searchTerm);
//   return debouncedSearch.cancel;
// }, [searchTerm]);

//   const onSearch = (searchTerm, item) => {
//     console.log(item +"------------")
//     console.log(value)
//     // setValue("")
//     onSearchChange(item);
//     setSelectedValue(item);
//     };

//     const handleExpandClick = () => {
//         setOpen(!open);
//     };
//   return (
//     <>
//       <div className="searchbar" >
   
//       <Autocomplete
//   freeSolo
//   id="free-solo"
//   options={data}
//   getOptionLabel={(option) => `${option.patientname}`}
//   open={open}
//   onOpen={() => setOpen(true)}
//   onClose={() => setOpen(false)}
//   value={selectedValue}
//   onInputChange={(event, newInputValue) => {
//     setSearchTerm(newInputValue); // trigger search
//   }}
//   onChange={(event, newValue) => {
//     onSearch(null, newValue);
//     setSelectedValue(newValue);
//   }}
//             renderInput={(params) => 
//             <TextField
//              {...params} 
//              placeholder="Search Patient"
//              InputProps={{
//               ...params.InputProps,
//               endAdornment: (
//                   <InputAdornment position="end">
//                       <IconButton onClick={handleExpandClick}>
//                        <SearchIcon />
//                       </IconButton>
//                   </InputAdornment>
//               ),
//           }}
             
//            //  onChange={(event) => setValue(event.target.value)} 
//               />
//             }
//             renderOption={(props, option) => (
//               <li {...props}>
//                 {option.patientname}-{option.phoneno}
//               </li>
//             )}
//           />
//         </div>
 
//     </>
//   );
// }
// export default Searchbar;










import { useState, useEffect, useMemo } from "react";
import axios from "../helper/axios";
import {
  TextField,
  InputAdornment,
  IconButton,
  Autocomplete,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import { useUser } from "../Provider";

const Searchbar = ({ onSearchChange }) => {
  const { userHospitalcode, userrole1, token } = useUser();
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  const debouncedSearch = useMemo(() => debounce(searchPatients, 500), []);

  useEffect(() => {
    if (value.trim().length > 2) {
      debouncedSearch(value);
    }
  }, [value]);

  async function searchPatients(searchTerm) {
    try {
      const res = await axios.get("/GetPatientAPI", {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          hospitalcode: userHospitalcode,
          userrole: userrole1,
          searchTerm: searchTerm,
        },
      });

      const result = res.data.patients || [];

      // if (searchTerm && searchTerm.length > 2 && result.length === 0) {
      //   toast.info("This patient is not present");
      // }

      setOptions(result);
    } catch (error) {
      console.error("Search failed:", error);
    }
  }

  const handleSelect = (event, newValue) => {
    if (newValue) {
      setSelectedValue(newValue);
      onSearchChange(newValue);
    }
  };

  return (
    <Autocomplete
      freeSolo
      id="search-patient"
      options={options}
      getOptionLabel={(option) =>
        `${option.patientname} - ${option.phoneno} - ${option.patientid}`
      }
      value={selectedValue}
      onChange={handleSelect}
      inputValue={value}
      onInputChange={(e, newInputValue) => setValue(newInputValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search by name, phone or ID"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          {option.patientname} - {option.phoneno} - {option.patientid}
        </li>
      )}
    />
  );
};

export default Searchbar;
